import * as _4 from 'lodash4';

export class TodoTaskFilterController {
  private taskFilters: any;
  private isFilterOpen: boolean;
  private headerTheme: string;
  private filter: any;
  private filterExpanded: boolean = false;

  constructor(
    private $scope: ng.IScope,
    private $state: ng.ui.IStateService,
    private FEATURE_PERSONAL_REMINDERS: string,
    private TodoFilterEnum: any,
    private appConfigModel: any
  ) {
    this.taskFilters = TodoFilterEnum.__keys__;
    if (!appConfigModel.isFeatureEnabled(FEATURE_PERSONAL_REMINDERS)) {
      this.taskFilters = _4.omit(this.taskFilters, 'REMINDER');
    }

    this.isFilterOpen = false;
    if (appConfigModel.navIconTheme) {
      this.headerTheme = appConfigModel.navIconTheme();
    }
  }

  toggleFilter() {
    this.filterExpanded = !this.filterExpanded;
  }

  changeFilter(filter: any): void {
    const title = filter.name;
    this.$state.get('my.todos').data.viewTitle = `To-Dos | ${title}`;
    this.$state.go('my.todos', { filterBy: filter.stateParam });
  }

  isFilteringActive(): boolean {
    return !_4.isEmpty(this.filter) && this.filter !== this.TodoFilterEnum.ALL_TODO_AND_EVENT;
  }
}
export class TodoTaskFilterComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/todo_task_filter/todo_task_filter.html';
  public controller: any = TodoTaskFilterController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    filter: '<?'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/todo_task_filter/todo_task_filter.ts